import ArrowLeftIcon from "@redotech/redo-icons/arrow-left.svg";
import { memo } from "react";

interface DetailPageBackButtonProps {
  onClick: () => void;
  label?: string;
}

/**
 * Back button used in the top-left corner of detail page top headers
 * (merchant detail, partner detail, …). Absolutely positioned within the
 * `topHeader` region so it overlays the centered content. Shared so both
 * pages render the same pixel-perfect affordance.
 */
export const DetailPageBackButton = memo(function DetailPageBackButton({
  onClick,
  label = "Back",
}: DetailPageBackButtonProps) {
  return (
    <div
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      role="button"
      style={{
        position: "absolute",
        top: "16px",
        left: "20px",
        display: "flex",
        alignItems: "center",
        gap: "var(--redo-spacing-xs)",
        fontSize: "13px",
        fontWeight: "var(--redo-font-weight-medium)",
        color: "#000000",
        cursor: "pointer",
      }}
      tabIndex={0}
    >
      <ArrowLeftIcon height={14} width={14} />
      <span>{label}</span>
    </div>
  );
});
